import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { AnnouncementWrapper } from "../model/Announcement";
import AnnouncementListApiRequest from "../request/AnnouncementListApiRequest";

 export const AnnouncementListApiService = async (request: AnnouncementListApiRequest): Promise<AnnouncementWrapper> => {
  const url = "/announcements/";
  const { data } = await axios.get(url, { params: request });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAnnouncementListApiService = (request: AnnouncementListApiRequest) =>
  useQuery<Promise<AnnouncementWrapper>, AxiosError, AnnouncementWrapper>(
    ["AnnouncementListApiService", request.page, request.employer_id], () =>
      AnnouncementListApiService(request)
  );

export default useAnnouncementListApiService;